import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';

import ApiStores from '../../../api/Stores/Stores';
import ApiStorePopup from '../../../api/StorePopup';

import { ReactComponent as StoreIcon } from '../../../assets/icons/icon-store.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import Selector from '../../Input/Selector';

import Config, { spanish } from '../../../config/config';

import { getSelectedEstado } from '../../../redux/actions/listaEstados';

export const StoreSelectorButton = ({ handleStoreSelect, selectedStore }) => (
  <div className={styles.storeButton}>
    <button type="button" onClick={handleStoreSelect}>
      <StoreIcon />
      <p>{selectedStore}</p>
      <ArrowDown />
    </button>
  </div>
);

export const StoreSelectorModal = ({
  active,
  handleStoreSelect,
  getSelectedStore,
  selectedStore,
}) => {
  const [estados, setEstados] = useState([]);
  const [content, setContent] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const localDataEstado = JSON.parse(
      sessionStorage.getItem('localDataEstado')
    );
    if (localDataEstado) {
      dispatch(
        getSelectedEstado(localDataEstado.IdEstado, localDataEstado.Estado)
      );
      getSelectedStore(localDataEstado.Estado);
    }
  }, []);

  useEffect(async () => {
    setContent(await ApiStorePopup.getContent());
  }, []);

  const getStoreList = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
    };

    try {
      const resp = await ApiStores.getEstadosList(payload);
      if (resp && resp?.ListaEstados?.length) {
        setEstados(resp?.ListaEstados[0].ListaEstados);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getStoreList();
  }, [getStoreList]);

  const selectEstado = (e) => {
    const selectedEstadoName = estados.filter(
      (estado) => estado.IdEstado === parseInt(e.target.value, 10)
    );
    dispatch(getSelectedEstado(e.target.value, selectedEstadoName[0].Estado));
    getSelectedStore(selectedEstadoName[0].Estado);
    sessionStorage.setItem(
      'localDataEstado',
      JSON.stringify(selectedEstadoName[0])
    );
    sessionStorage.removeItem('apiProducts');
  };

  const isDisabled = selectedStore === null || selectedStore === undefined;

  return (
    <div
      className={`${styles.storeModal} ${
        active ? styles.storeModalActive : ''
      }`}
    >
      <div className={styles.storeModalContent}>
        <div className={styles.header}>
          <StoreIcon />
          <p>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</p>
        </div>
        <p className={styles.description}>
          {spanish ? content?.DescriptionSpanish : content?.DescriptionEnglish}
        </p>
        <form className={styles.form}>
          <div className={styles.field}>
            <Selector
              title={spanish ? 'Estado:' : 'State:'}
              placeholder={
                spanish ? 'Selecciona tu Estado' : 'Select your State'
              }
              options={estados}
              onChange={selectEstado}
              getSelectedStore={getSelectedStore}
            />
          </div>
          <div className={styles.field}>
            <button
              type="submit"
              className={`btn btn-yellow ${isDisabled ? 'disabled' : ''}`}
              onClick={handleStoreSelect}
              disabled={isDisabled}
            >
              {spanish ? content?.ButtonSpanish : content?.ButtonEnglish}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
